module.exports = __webpack_public_path__ + "static/parade-2020-house49-737dea3b37ca32cfc7f7e7c99d2f9c10.jpg";